import getApi from '../../api'
import { Question } from '../../model/Questionnaire'

export const addImportantInformation = (id: number) =>
  getApi().post<Question>(`/question_templates/${id}/important_informations`)
